<template>
  <ValidationProvider
    :name="$t('serialnumber_repair_number')"
    :rules="{ required: true }"
    v-slot="{ errors }"
  >
    <v-autocomplete
      :items="repairNumberList"
      item-text="Number"
      item-value="Number"
      :disabled="isAllTextFieldDisable"
      :search-input.sync="searchInput"
      v-model="editedRepair"
      :loading-text="$t('common_get_data')"
      :no-data-text="$t('common_no_results')"
      :ref="refName"
      @keyup.enter="keyupEnter"
      :error-messages="errors[0]"
      @change="setRepairNumber"
      @click="setRepair(fatherRepairNumber)"
      :loading="isLoading"
      return-object
    >
      <template v-slot:append-item>
        <div v-intersect="isScrollBarBottom" />
      </template>
      <template v-slot:label>
        <span class="red--text">
          <strong>* </strong>
        </span>
        {{ $t('serialnumber_repair_number') }}
      </template>
      <template v-slot:selection="{ item }">
        {{ setSelectText(item) }}
      </template>
    </v-autocomplete>
  </ValidationProvider>
</template>
<script>
import { HttpRepair } from '@/js/http-Manager'

export default {
  name: 'RepairNumberAutocomplete',
  props: {
    editedQuotationIndex: {
      type: Number
    },
    isAllTextFieldDisable: {
      type: Boolean,
      default: false
    },
    refName: {
      type: String
    },
    fatherRepairNumber: {
      type: String
    },
    customerId: {
      type: String
    },
    licensePlate: {
      type: String
    }
  },
  data: () => ({
    repairNumberList: [],
    searchInput: null,
    page: 1,
    perPage: 10,
    tempWatchNumber: '',
    searchCount: 0,
    getIntersectingObj: null,
    isFinish: false,
    isLoading: false,
    editedRepair: { Number: '' },
    defaultRepair: { Number: '' }
  }),
  async mounted () {
    await this.setRepair(this.fatherRepairNumber)
  },
  watch: {
    async searchInput (val) {
      this.tempWatchNumber = val
      this.page = 1
      this.repairNumberList = []
      this.isFinish = true
      await this.getNumberCount()
      await this.getNumber()
      this.isFinish = false
    },

    async getIntersectingObj (newVal, oldVal) {
      // 舊物件和新物件(getIntersectingObj) 相減  時間間隔太短不能觸發
      if (newVal && newVal.length > 0 && !this.isFinish) {
        let timeDiff = newVal[0].time - (oldVal ? oldVal[0].time : 0)
        if (timeDiff > 100) {
          this.page += 1
          await this.getNumber()
        }
      }
    },
    async fatherRepairNumber (val) {
      await this.setRepair(val)
    }
  },
  methods: {
    async setRepair (val) {
      if (!val) {
        this.tempWatchNumber = ''
        this.page = 1
        this.repairNumberList = []
        this.isFinish = true
        await this.getNumberCount()
        await this.getNumber()
        this.isFinish = false
        this.editedRepair = JSON.parse(JSON.stringify(this.defaultRepair))
      } else {
        this.tempWatchNumber = val
        this.page = 1
        this.repairNumberList = []
        this.isFinish = true
        await this.getNumberCount()
        await this.getNumber()
        this.isFinish = false
        this.editedRepair = JSON.parse(JSON.stringify({ Number: val }))
      }
    },
    keyupEnter (event) {
      this.$refs[this.refName].isMenuActive = false
      this.$refs[this.refName].isFocused = false
      this.$emit('keyupEnter', event)
    },
    setRepairNumber () {
      this.$emit('setRepairNumber', this.editedRepair)
    },
    async getNumberCount () {
      let param = {
        searchNumber: this.tempWatchNumber,
        customerId: this.customerId,
        licensePlate: this.licensePlate
      }
      let response = await HttpRepair.GetRepairNumberCountByCustomerId(param)
      this.searchCount = response.status === 200 ? response.data.Data : 0
    },
    async getNumber () {
      if (this.searchCount > (this.page - 1) * this.perPage && this.searchCount !== 0) {
        this.isLoading = true
        let param = {
          SearchNumber: this.tempWatchNumber,
          CustomerId: this.customerId,
          LicensePlate: this.licensePlate,
          Page: this.page,
          PerPage: this.perPage
        }
        let response = await HttpRepair.GetRepairNumberByCustomerId(param)
        if (response.status === 200) {
          this.repairNumberList = [...this.repairNumberList, ...response.data.Data]
        } else {
          this.repairNumberList = []
        }
        this.isLoading = false
      }
    },
    async isScrollBarBottom (getIntersectingObj) {
      this.getIntersectingObj = getIntersectingObj
    },
    setSelectText (item) {
      return item.Number
    }
  }
}
</script>
